import { createContext, useContext, useState, useEffect } from "react";
import { collection, getDocs, where, query } from "firebase/firestore";
import {db} from '../config/firebaseConfig'

const TreeViewContext = createContext();

export const TreeViewProvider = ({ children }) => {
    const [selectedID, setSelectedID] = useState(null);
    const [childIDList, setChildIDList] = useState([]);
    const [selectedAndChildIDList, setSelectedAndChildIDList] = useState([]);
    const [selectedNode, setSelectedNode] = useState(null);
    const [deviceNameMap, setDeviceNameMap] = useState({}); // 追加
    const currentProjectID = localStorage.getItem("currentProjectID");


    // ✅ Firestoreから装置名マップを取得してContextに保存
    useEffect(() => {
        const fetchDeviceNameMap = async () => {
            
            const q = query(
                collection(db, "00_DeviceMasterTable"),
                where("projectID", "==", currentProjectID)
            );
        const snapshot = await getDocs(q);
        const map = {};
        snapshot.forEach((doc) => {
            const data = doc.data();
            //   console.log('data', data)
            map[data.masterID] = data.name;
        });
        setDeviceNameMap(map);
        };
    
        fetchDeviceNameMap();
    }, []);
    

    const setSelectedNodeID = (selectedNode, allNodes) => {
        const selectedNodeID = selectedNode.id;
        setSelectedID(selectedNodeID);
        setSelectedNode(selectedNode);
        // console.log('selectedID', selectedID)
        
        // ✅ JSTree の `children_d` から配下の子ノードのIDを取得
        const childrenIDs = selectedNode.children_d || []; // 存在しない場合は空配列
        setChildIDList(childrenIDs);
        // console.log('\nchildIDList', childIDList)
    
        // selectedID + 子要素をまとめたリスト。master_をなくしたver
        const selectedAndChilds = [selectedNodeID, ...childrenIDs].map(item => item.replace('master_', ''));
        setSelectedAndChildIDList(selectedAndChilds);

        // // ✅ デバッグ用ログ出力
        // console.log("🌳 JSTree ノード選択:");
        // console.log("🌳 node:", selectedNode);
        // console.log("➡️ 選択されたID:", selectedNodeID);
        // console.log("📝 選択ID + 子ノードリスト:", selectedAndChildIDList);
        // console.log("📝 選択IDのtype:", selectedNode.type);

    };
    

    return (
        <TreeViewContext.Provider value={{ 
            selectedID, 
            childIDList, 
            selectedAndChildIDList, 
            selectedNode,
            setSelectedNodeID,
            setSelectedNode,
            setDeviceNameMap,
            deviceNameMap, // 追加
        }}>
            {children}
        </TreeViewContext.Provider>
    );
};

export const useTreeView = () => useContext(TreeViewContext);
export default TreeViewContext;

